import React, { Fragment, ReactElement } from 'react';
import { List } from '../../store/system/types';
import classnames from 'classnames';

let Styles: any;

try {
  Styles = require('./DropDownListIcon_' + process.env.REACT_APP_CODE_TENANT + '.module.scss');
} catch {
  Styles = require('./DropDownListIcon.module.scss');
}

interface DropDownListIconProps {
  id: string;
  name: string;
  onChange: any;
  data: List[];
  styleClass: string;
  className?: string;
  onBlur: any;
  value: string;
  icon: ReactElement;
  tabIndex?: number;
  disabled?: boolean;
}

const DropDownListIcon: React.FC<DropDownListIconProps> = (props: DropDownListIconProps) => {
  const { data, styleClass, className: styleDivClass, icon, disabled, ...rest } = props;
  return (
    <Fragment>
      <div className={Styles.selectGroup}>
        <div className={Styles.icon}>{icon}</div>
        <div className={styleDivClass}>
          <select
            className={classnames(Styles.selectIcon, styleClass)}
            {...rest}
          >
            {data.map((item) => (
              <option disabled={disabled} key={item.id} value={item.id}>
                {item.value}
              </option>
            ))}
          </select>
        </div>
      </div>
    </Fragment>
  );
};

export default DropDownListIcon;
